var map = {
	"./app-icon.svg": 1741,
	"./caret-right-icon.svg": 1742,
	"./chrome-icon.webp": 1743,
	"./edge-icon.webp": 1744,
	"./firefox-icon.webp": 1745,
	"./opera-icon.webp": 1746,
	"./safari-icon.webp": 1747,
	"./unknown-icon.webp": 1748
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1740;